import { styled } from '@spazious/dollhouse-theme';

import { BaseExtendProps, createBase } from '../Base/index.js';

export type SelectOptionElement = HTMLOptionElement;
export interface SelectOptionProps
  extends BaseExtendProps<React.OptionHTMLAttributes<HTMLOptionElement>> {}

export const SelectOption = styled(createBase('option')).withConfig({
  displayName: 'SelectOption',
})<SelectOptionProps>``;
